/**
 * Site-wide scripts.
 */
import throttle from 'lodash.throttle';
import ClipboardJS from 'clipboard';
import { anchorLinkHandler, removeClass } from '../utils';
import { accordion } from '../utils/accordion';
import { setupFixedSidebar, addStickyClass } from './sticky';
import resizeListener from './resizeListener';
import dataWrapperMessageListener from './dataWrapperMessageListener';
import podcastTranscriptOpen from './podcastTranscriptOpen';
import unmuteVideo from './unmuteCustomHeaderVideo';

unmuteVideo();

// Run site components
document.addEventListener('DOMContentLoaded', () => {
  // call sidebar setup
  setupFixedSidebar('.left-sidebar');

  // Increase the share bar offset for articles with full width header images.
  const fullHeader = document.querySelector('.header-full-bg');
  const republishSticker = document.querySelector('.republish-sticker');
  let shareBarOffset = 40;
  let republishOffset = 40;

  if (fullHeader) {
    shareBarOffset += fullHeader.getBoundingClientRect().height;
  }

  if (republishSticker) {
    republishOffset = republishSticker
      .getBoundingClientRect().top - window.pageYOffset - 20;
  }

  /**
   * Sticky wrapper functions
   */
  let lastScrollTop = 0;
  const onScrollFunctions = () => {
    removeClass('.left-sidebar', 'not-top');
    addStickyClass('.share.vertical', 'sticky', shareBarOffset);
    addStickyClass('.republish-sticker', 'sticky', republishOffset);

    const scrollTopVal = window.pageYOffset
      || document.documentElement.scrollTop;
    // Enable special behavior for header on scroll up.
    // If user is scrolling down, handle sticky class.
    if (scrollTopVal > lastScrollTop) {
      addStickyClass('.header-site', 'scrolling', 120);
    // If user is scrolling up, restore the top scrolled state sooner.
    } else if (500 > scrollTopVal) {
      removeClass('.header-site', 'scrolling');
    }
    lastScrollTop = 0 >= scrollTopVal ? 0 : scrollTopVal; // For Mobile or negative scrolling
  };

  // throttle our scroll events here with lodash.throttle
  window.addEventListener('scroll', throttle(onScrollFunctions, 100), false);

  // accordion toggle for our newsletter index
  accordion('.article-list', '.header');

  resizeListener();

  dataWrapperMessageListener();

  const podcastTranscriptCheck = document.querySelector('#view-transcript');
  if (podcastTranscriptCheck) {
    podcastTranscriptOpen(podcastTranscriptCheck);
  }

  // clipboard button
  const btns = document.querySelectorAll('[data-clipboard-target]');
  const clipboard = new ClipboardJS(btns); // eslint-disable-line no-unused-vars

  const linksToAnchors = document.querySelectorAll('a[href^="#"]');

  linksToAnchors.forEach((each) => (each.onclick = anchorLinkHandler)); // eslint-disable-line no-param-reassign, no-return-assign
});
